import React from 'react';

const CategoryForm = ({ formData, handleChange, errors }) => {
  return (
    <div className="admin__modal-column">
      <div className="form-group">
        <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Name"
            maxLength="25"
            className={errors.name ? 'error' : ''}
        />
        <div className="error-message-container">
          {errors.name && <p className="error-message">{errors.name}</p>}
        </div>
      </div>

    </div>
  );
};

export default CategoryForm;